import { Localization } from "../../../common/localizable-component";
import { ImageLocalization } from "./image-types";

export const IMAGE_LOCALIZATION: Localization<ImageLocalization> = {
  en: {
    ariaLabel: {
      phone: "Call phone number {0}",
      mail: "Send a mail to {0}",
      download: "Download {0}",
      default: "Navigate to {0}"
    }
  },
  de: {
    ariaLabel: {
      phone: "Rufe {0} an",
      mail: "Verfasse eine E-Mail an {0}",
      download: "{0} herunterladen",
      default: "Navigiere zu {0}"
    }
  },
  sv: {
    ariaLabel: {
      phone: "Ring telefonnummer {0}",
      mail: "Skicka e-post till {0}",
      download: "Ladda ner {0}",
      default: "Gå till {0}"
    }
  },
  nl: {
    ariaLabel: {
      phone: "Bel telefoonnummer {0}",
      mail: "Stuur een mail naar {0}",
      download: "Download {0}",
      default: "Navigeer naar {0}"
    }
  },
  it: {
    ariaLabel: {
      phone: "Chiama il numero di telefono {0}",
      mail: "Manda una mail a {0}",
      download: "Scarica {0}",
      default: "Naviga su {0}"
    }
  },
  hu: {
    ariaLabel: {
      phone: "Telefonszám hívása {0}",
      mail: "E-mail küldése {0}",
      download: "{0} db fájl letöltése",
      default: "Tovább a {0}"
    }
  },
  da: {
    ariaLabel: {
      phone: "Ring til nummer {0}",
      mail: "Send mail til {0}",
      download: "Download {0}",
      default: "Gå til {0}"
    }
  },
  fr: {
    ariaLabel: {
      phone: "Appeler le numéro de téléphone {0}",
      mail: "Envoyer un mail à {0}",
      download: "Télécharger {0}",
      default: "Naviguer à {0}"
    }
  },
  es: {
    ariaLabel: {
      phone: "Llama al número de teléfono {0}",
      mail: "Enviar un email a {0}",
      download: "Descargar {0}",
      default: "Navega a {0}"
    }
  },
  pl: {
    ariaLabel: {
      phone: "Zadzwoń pod numer telefonu {0}",
      mail: "Wyślij maila na adres {0}",
      download: "Pobierz {0}",
      default: "Przejdź do {0}"
    }
  },
  ro: {
    ariaLabel: {
      phone: "Sună la numărul de telefon {0}",
      mail: "Trimiteți un e-mail la {0}",
      download: "Descărcați {0}",
      default: "Navigați la {0}"
    }
  },
  hr: {
    ariaLabel: {
      phone: "Nazovi telefonski broj {0}",
      mail: "Pošalji e-poštu na {0}",
      download: "Preuzmi {0}",
      default: "Idite do {0}"
    }
  },
  cs: {
    ariaLabel: {
      phone: "Volejte na telefonní číslo {0}",
      mail: "Pošlete mail na {0}",
      download: "Stáhnout {0}",
      default: "Přejděte na {0}"
    }
  },
  sl: {
    ariaLabel: {
      phone: "Pokličite telefonsko številko {0}",
      mail: "Pošljite pošto na {0}",
      download: "Prenesite {0}",
      default: "Navigacija v {0}"
    }
  }
};
